import Alpine from "alpinejs";
import { trackEvent } from "../../modules/track/trackEvent";
import { trackCarouselSlide } from "../../modules/track/modules/carousel/trackCarousel.js";

Alpine.magic("track", () => (obj) => {
  trackEvent(obj);
});

Alpine.magic("trackCarouselSlide", () => (carousel, carouselContext) => {
  trackCarouselSlide(carousel, carouselContext);
});
